import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './index.css';
import './App.css';

// ---- Überblick ----
import Aktuelles from './pages/ueberblick/hintergrund';
//import Meldeentwicklung from './pages/ueberblick/meldeentwicklung';

// ---- Krebsgesamt ----
import HaeufigsteKrebserkrankungen2 from './pages/krebsgesamt/haeufigste_krebserkrankungen';
import RelativeSurvival4 from './pages/krebsgesamt/ueberleben_5';
import ZeitverlaufKrebsgesamt from './pages/krebsgesamt/zeitverlauf';

import Regional from './pages/krebsgesamt/Regional';
import RegionalMapChloropeth from './pages/krebsgesamt/regionale_verteilung';

// ---- Entitäten ----
import Altersverteilung from './pages/entit/altersverteilung';
import RelativeSurvival2 from './pages/entit/rs_entit';
import Alltherapie from './pages/entit/therapie';
import KrebsartenVerteilung from './pages/entit/histo';
import Tnm from './pages/entit/tnm';
import Lokal from './pages/entit/lokal';
import Stage from './pages/entit/stage';
import Grading from './pages/entit/grading';
import Met from './pages/entit/met';

// ---- Methodik ----
import QI from './pages/methodik/datenqualitaet';
import Definitionentitaeten from './pages/methodik/definitionen';
import Datengrundlage from './pages/methodik/datengrundlage';
import KlinischeKennzahlen from './pages/methodik/kennzahlen';

// ---- Shared UI ----
import Header from './components/Header';
import Footer from './components/Footer';
import Logo from './assets/data/logo.png';


/** Compute SubNav items based on route and pass them into Header */
function HeaderWithItems() {
  const location = useLocation();
  let subNavItems = [];

  if (location.pathname.startsWith('/ueberblick')) {
    subNavItems = [
      { name: 'Hintergrund', path: '/ueberblick/hintergrund' },
    ];
  } else if (location.pathname.startsWith('/krebsgesamt')) {
    subNavItems = [
      { name: 'Neuerkrankungen im Zeitverlauf', path: '/krebsgesamt/zeitverlauf' },
      { name: 'Häufigste Krebserkrankungen', path: '/krebsgesamt/haeufigste_krebserkrankungen' },
      { name: 'Überleben', path: '/krebsgesamt/ueberleben_5' },
      { name: 'Regionale Verteilung', path: '/krebsgesamt/regionale_verteilung' },
    ];
  } else if (location.pathname.startsWith('/entit')) {
    subNavItems = [
      { name: 'Altersverteilung', path: '/entit/altersverteilung' },
      { name: 'TNM', path: '/entit/tnm' },
      { name: 'Stadium', path: '/entit/stage' },
      { name: 'Grading', path: '/entit/grading' },
      { name: 'Lokalisation', path: '/entit/lokal' },
      { name: 'Histologie', path: '/entit/histo' },
      { name: 'Metastasierung', path: '/entit/met' },
      { name: 'Therapien', path: '/entit/therapie' },
      { name: 'Relatives Überleben', path: '/entit/rs_entit' },
    ];
  } else if (location.pathname.startsWith('/methodik')) {
    subNavItems = [
      { name: 'Datengrundlage', path: '/methodik/datengrundlage' },
      { name: 'Kennzahlen', path: '/methodik/kennzahlen' },
      { name: 'Definitionen', path: '/methodik/definitionen' },
      { name: 'Datenqualität', path: '/methodik/datenqualitaet' },
    ];
  }

  return <Header logoSrc={Logo} subNavItems={subNavItems} />;
}

function App() {
  return (
    <div className="App">
      <Router>
        <HeaderWithItems />

        <div className="main-content">
          <Routes>
            {/* ---------- Überblick ---------- */}
            <Route path="/" element={<Navigate to="/ueberblick/hintergrund" replace />} />
            <Route path="/ueberblick/hintergrund" element={<Aktuelles />} />
  

            {/* ---------- Krebsgesamt ---------- */}
            <Route path="/krebsgesamt/haeufigste_krebserkrankungen" element={<HaeufigsteKrebserkrankungen2 />} />
            <Route path="/krebsgesamt/ueberleben_5" element={<RelativeSurvival4 />} />
            <Route path="/krebsgesamt/zeitverlauf" element={<ZeitverlaufKrebsgesamt />} />
            <Route path="/krebsgesamt/" element={<ZeitverlaufKrebsgesamt />} />
         
            <Route path="/krebsgesamt/regional" element={<Regional />} />
            <Route path="/krebsgesamt/regionale_verteilung" element={<RegionalMapChloropeth />} />

            {/* ---------- Entitäten ---------- */}
            <Route path="/entit/" element={<Altersverteilung />} />
            <Route path="/entit/altersverteilung" element={<Altersverteilung />} />
            <Route path="/entit/tnm" element={<Tnm />} />
            <Route path="/entit/stage" element={<Stage />} />
            <Route path="/entit/grading" element={<Grading />} />
            <Route path="/entit/lokal" element={<Lokal />} />
            <Route path="/entit/histo" element={<KrebsartenVerteilung />} />
            <Route path="/entit/met" element={<Met />} />
            <Route path="/entit/therapie" element={<Alltherapie />} />
            <Route path="/entit/rs_entit" element={<RelativeSurvival2 />} />

            {/* ---------- Methodik ---------- */}
            <Route path="/methodik/datenqualitaet" element={<QI />} />
            <Route path="/methodik/definitionen" element={<Definitionentitaeten />} />
            <Route path="/methodik/datengrundlage" element={<Datengrundlage />} />
            <Route path="/methodik/" element={<Datengrundlage />} />
            <Route path="/methodik/kennzahlen" element={<KlinischeKennzahlen />} />

            {/* ---------- 404 ---------- */}
            <Route path="*" element={<Navigate to="/ueberblick/hintergrund" replace />} />
          </Routes>
        </div>

        <Footer />
      </Router>
    </div>
  );
}

export default App;
